var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C9.7669 19 9.54335 18.9074 9.37852 18.7426C9.21369 18.5777 9.12109 18.3542 9.12109 18.1211V1.87891C9.12109 1.64581 9.21369 1.42225 9.37852 1.25743C9.54335 1.0926 9.7669 1 10 1C10.2331 1 10.4567 1.0926 10.6215 1.25743C10.7863 1.42225 10.8789 1.64581 10.8789 1.87891V18.1211C10.8789 18.3542 10.7863 18.5777 10.6215 18.7426C10.4567 18.9074 10.2331 19 10 19Z",
    fill: "#B1B2BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1211 10.8789H1.87891C1.64581 10.8789 1.42225 10.7863 1.25743 10.6215C1.0926 10.4567 1 10.2331 1 10C1 9.7669 1.0926 9.54335 1.25743 9.37852C1.42225 9.21369 1.64581 9.12109 1.87891 9.12109H18.1211C18.3542 9.12109 18.5777 9.21369 18.7426 9.37852C18.9074 9.54335 19 9.7669 19 10C19 10.2331 18.9074 10.4567 18.7426 10.6215C18.5777 10.7863 18.3542 10.8789 18.1211 10.8789Z",
    fill: "#B1B2BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9b8ec041f06ca37a57c1cc1aaae3e982.svg";
export { ForwardRef as ReactComponent };